import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Trustpilot: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size ?? 36} height={size ?? 34} fill="none" data-testid="trustpilot-icon" style={style} viewBox="0 0 36 36">
      <path
        fill={color ?? '#fff'}
        d="m25.623 23.81 3.194 9.833-10.811-7.858 7.617-1.974ZM35.5 13.079H22.134L18.007.359 13.866 13.08.5 13.063l10.824 7.87-4.142 12.709 10.824-7.857 6.683-4.852L35.5 13.078Z"
      />
    </svg>
  );
};

export default Trustpilot;
